import React from 'react';
import Icon from '../../../components/AppIcon';

const MemberStatsCard = ({ icon, label, value, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    accent: 'bg-accent/10 text-accent'
  };

  return (
    <div className="bg-card border border-border rounded-xl p-3 sm:p-4 md:p-6 transition-athletic hover-lift">
      <div className="flex items-start justify-between mb-2 sm:mb-4">
        <div className={`w-9 h-9 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-lg ${colorClasses?.[color]} flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={20} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md text-[10px] sm:text-xs font-medium ${
            trend === 'up' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{trendValue}</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-lg sm:text-2xl md:text-3xl font-heading font-bold text-foreground mb-0.5 sm:mb-1 data-text leading-none">
          {value}
        </p>
        <p className="text-[10px] sm:text-sm caption text-muted-foreground leading-tight">{label}</p>
      </div>
    </div>
  );
};

export default MemberStatsCard;